import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconApprovals$1 = /*@__PURE__*/ proxyCustomElement(class WppIconApprovals extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-approvals", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M9.78033 0.71967C9.48744 0.426777 9.01256 0.426777 8.71967 0.71967C8.42678 1.01256 8.42678 1.48744 8.71967 1.78033L9.93934 3H9.5C5.35786 3 2 6.35786 2 10.5C2 14.6421 5.35786 18 9.5 18C13.6421 18 17 14.6421 17 10.5C17 10.0858 16.6642 9.75 16.25 9.75C15.8358 9.75 15.5 10.0858 15.5 10.5C15.5 13.8137 12.8137 16.5 9.5 16.5C6.18629 16.5 3.5 13.8137 3.5 10.5C3.5 7.20664 6.15341 4.53301 9.43904 4.5003L8.71967 5.21967C8.42678 5.51256 8.42678 5.98744 8.71967 6.28033C9.01256 6.57322 9.48744 6.57322 9.78033 6.28033L12.0303 4.03033C12.3232 3.73744 12.3232 3.26256 12.0303 2.96967L9.78033 0.71967ZM13.5201 6.95963C13.8185 7.24688 13.8276 7.72166 13.5404 8.0201L9.69039 12.0201C9.549 12.167 9.35391 12.25 9.15002 12.25C8.94613 12.25 8.75104 12.167 8.60965 12.0201L6.95963 10.3057C6.67239 10.0073 6.68147 9.53249 6.97991 9.24525C7.27835 8.95801 7.75314 8.96709 8.04038 9.26553L9.15003 10.4185L12.4596 6.9799C12.7469 6.68146 13.2217 6.67239 13.5201 6.95963Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-approvals-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-approvals", "wpp-icon-approvals-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-approvals-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-approvals-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconApprovals$1);
      }
      break;
  } });
}

const WppIconApprovals = WppIconApprovals$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconApprovals, defineCustomElement };
